import { GroupCallLocator, GroupLocator, TeamsMeetingLinkLocator } from '@azure/communication-calling';
import { getExistingThreadIdFromURL } from './getThreadId';
import { pushQSPUrl } from './pushQSPUrl';
import { generateUUID } from '../../../helpers/guid';

/**
 * Get ACS user token from the Contoso server.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchTokenResponse = async (): Promise<any> => {
  const response = await fetch('http://localhost:8080/token'); // FIXED 8080
  if (response.ok) {
    const responseAsJson = await response.json();
    const token = responseAsJson.token;
    if (token) {
      return responseAsJson;
    }
  }
  throw 'Invalid token response';
};

/**
 * Get group id from the url's query params.
 */
export const getGroupIdFromUrl = (): GroupLocator | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const gid = urlParams.get('groupId');
  return gid ? { groupId: gid } : undefined;
};

export const createGroupId = (): GroupLocator => ({ groupId: generateUUID() });

/**
 * Get teams meeting link from the url's query params.
 */
export const getTeamsLinkFromUrl = (): TeamsMeetingLinkLocator | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const teamsLink = urlParams.get('teamsLink');
  return teamsLink ? { meetingLink: decodeURIComponent(teamsLink) } : undefined;
};

export const ensureJoinableTeamsLinkPushedToUrl = (teamsLink: TeamsMeetingLinkLocator): void => {
  if (!getTeamsLinkFromUrl()) {
    pushQSPUrl({ name: 'teamsLink', value: encodeURIComponent(teamsLink.meetingLink) });
  }
};

export const ensureJoinableCallLocatorPushedToUrl = (callLocator: GroupCallLocator): void => {
  if (!getGroupIdFromUrl()) {
    pushQSPUrl({ name: 'groupId', value: callLocator.groupId });
  }
};

export const ensureJoinableChatThreadPushedToUrl = (chatThreadId: string): void => {
  if (!getExistingThreadIdFromURL()) {
    pushQSPUrl({ name: 'threadId', value: chatThreadId });
  }
};

/*
 * TODO:
 *  Remove this method once the SDK improves error handling for unsupported browser.
 */
export const isOnIphoneAndNotSafari = (): boolean => {
  const userAgent = navigator.userAgent;

  // Chrome uses 'CriOS' in user agent string and Firefox uses 'FxiOS' in user agent string.
  return userAgent.includes('iPhone') && (userAgent.includes('FxiOS') || userAgent.includes('CriOS'));
};

export const isSmallScreen = (): boolean => window.innerWidth < 700 || window.innerHeight < 400;

export const navigateToHomePage = (): void => {
  window.location.href = window.location.href.split('?')[0];
};